import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  AssetBucket = 'AssetBucket',
  AdvisorAssetBucket = 'AdvisorAssetBucket',
}

export const queryKeys = {
  assetBucket: () => [QueryFeature.Settings, QueryKey.AssetBucket],
  advisorAssetBucket: () => [QueryFeature.Settings, QueryKey.AdvisorAssetBucket],
};
